export const ADDRESSES_RUIAN_ID_CHANGE = 'ADDRESSES_RUIAN_ID_CHANGE'

export const ADDRESSES_GET_FIRMS_ON_ADDRESS_SUMMARY_REQUEST = (id) =>
    `ADDRESSES_GET_FIRMS_ON_ADDRESS_SUMMARY_${id}_REQUEST`
export const ADDRESSES_GET_FIRMS_ON_ADDRESS_TABLE_REQUEST = (id) => `ADDRESSES_GET_FIRMS_ON_ADDRESS_TABLE_${id}_REQUEST`
export const ADDRESSES_FIRMS_ON_ADDRESS_DATA_RECEIVED = 'ADDRESSES_FIRMS_ON_ADDRESS_DATA_RECEIVED'
export const ADDRESSES_FIRMS_ON_ADDRESS_TABLE_CHANGE = 'ADDRESSES_FIRMS_ON_ADDRESS_TABLE_CHANGE'
export const ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_TRUE = 'ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_TRUE'
export const ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_FALSE = 'ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_FALSE'
